var map = {
	"./afc_bournemouth.png": 862,
	"./arsenal_fc.png": 7047,
	"./aston_villa.png": 2297,
	"./brentford_fc.png": 3881,
	"./brighton__hove_albion.png": 9192,
	"./burnley_fc.png": 3676,
	"./chelsea_fc.png": 9492,
	"./crystal_palace.png": 7430,
	"./everton_fc.png": 7616,
	"./fulham_fc.png": 7450,
	"./ipswich_town.png": 7761,
	"./leeds_united.png": 8938,
	"./leicester_city.png": 3715,
	"./liverpool_fc.png": 5295,
	"./manchester_city.png": 8299,
	"./manchester_united.png": 5551,
	"./newcastle_united.png": 3871,
	"./nottingham_forest.png": 1386,
	"./southampton_fc.png": 7351,
	"./sunderland_afc.png": 2830,
	"./tottenham_hotspur.png": 35,
	"./west_ham_united.png": 3903,
	"./wolverhampton_wanderers.png": 1389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4386;